if (!customElements.get('footer-details')) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet && !this.openDefault) {
        this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        this.open = this.openDefault;
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }

  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

(() => {
  if (window.location.pathname !== '/collections/a380-series') return;

  const widths = [355, 450, 535, 710, 900, 1070, 1420];
  const images = {
    '/products/a380-series-retractable-awning-manual': {
      src: 'https://cdn.shopify.com/s/files/1/0996/6085/7715/t/16/assets/besitsol-a380-manual-thumb-v2.png?v=1786100006',
      alt: 'BESITSOL A380 Standard manual crank retractable awning'
    },
    '/products/a380-series-retractable-awning-motorized': {
      src: 'https://cdn.shopify.com/s/files/1/0996/6085/7715/t/16/assets/besitsol-a380-motorized-thumb-v2.png?v=1786100010',
      alt: 'BESITSOL A380 Upgraded motorized retractable awning with remote'
    },
    '/products/a380-series-retractable-awning-luxury-motorized-led': {
      src: 'https://cdn.shopify.com/s/files/1/0996/6085/7715/t/16/assets/besitsol-a380-led-thumb-v2.png?v=1786100014',
      alt: 'BESITSOL A380 Luxury motorized retractable awning with warm LED lighting'
    }
  };

  const applyA380CardImages = () => {
    Object.entries(images).forEach(([productPath, image]) => {
      document.querySelectorAll(`a[href*="${productPath}"]`).forEach((link) => {
        const card = link.closest('.product-card') || link.closest('.f-column') || link.closest('li');
        const target = card?.querySelector('.product-card__image--main img') || card?.querySelector('img');

        if (!target) return;

        target.src = `${image.src}&width=535`;
        target.srcset = widths.map((width) => `${image.src}&width=${width} ${width}w`).join(', ');
        target.alt = image.alt;
        target.dataset.besitsolA380CardFixed = 'true';
      });
    });
  };

  applyA380CardImages();
  document.addEventListener('DOMContentLoaded', applyA380CardImages);
  window.addEventListener('load', applyA380CardImages);

  const grid = document.getElementById('ProductGridContainer') || document.body;
  new MutationObserver(applyA380CardImages).observe(grid, { childList: true, subtree: true });
})();
